export default class Notification {
  /**
   * Create new notification and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  /**
   * @return {Date}
   */
  get publishedUtc () {
    return this._publishedUtc
  }

  /**
   * @param {string} value
   */
  set publishedUtc (value) {
    this._publishedUtc = value ? new Date(value) : null
  }

    /**
   * @return {Date}
   */
  get lastEditedUtc () {
    return this._lastEditedUtc
  }

  /**
   * @param {string} value
   */
  set lastEditedUtc (value) {
    this._lastEditedUtc = value ? new Date(value) : null
  }
}
